var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPriorityHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H21V21H17V3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H7V21H3V15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H14V21H10V9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPriorityHigh);
export default __webpack_public_path__ + "static/media/icon-priority-high.0689453f77300c8a4b8a30e4639fc465.svg";
export { ForwardRef as ReactComponent };